import { ReferenceInputProps, InputProps, ReferenceInput, SelectInput } from "react-admin"

interface Props extends Omit<InputProps, "source"> {
  source?: string
}

const BillGroupRefInput = (
  props: Props & Omit<Omit<ReferenceInputProps, "source">, "reference" | "children">,
) => (
  <ReferenceInput source="group_id" reference="bill_groups">
    <SelectInput fullWidth={props.fullWidth} optionText="title" {...props} />
  </ReferenceInput>
)

BillGroupRefInput.defaultProps = {
  source: "group_id",
}

export { BillGroupRefInput }
